import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Typography, Grid, 
         FormControl, InputLabel, Select, MenuItem,  
        TextField, InputAdornment, Button} from '@mui/material'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import axios from 'axios'
import { SettlementLetterPDF, getProps } from '../../../letters/SettlementLetter'
import { PDFDate } from '../../../misc/dates'
import { pdf } from '@react-pdf/renderer'
import FileSaver from 'file-saver'
import { getPaidFillData, axiosErrorHandling, getPartialFillData } from '../../../misc/other'
import { SuccessAlert } from '../../../alerts/Success'
import { ErrorAlert } from '../../../alerts/ErrorAlert'



export const ProcessPhysicalPayment = ()=>{

const location = useLocation()
const context = JSON.parse(window.localStorage.getItem('usercontext'))
const totalDue = location.state.totalDue
const file_name = context.customer_number.toString() + '_SettlementLetter_'+ PDFDate +'.pdf'
const accounts = location.state.paymentInfo.accounts
const fillData = getPaidFillData(accounts, totalDue)

    

    const [type, setType] = React.useState('')
    const [number, setNumberChange] =React.useState(0) 
    const [ammount, setAmmount] = React.useState(totalDue)
    const [processingPayment, setProcessingPayment] = React.useState(false)
    const [error, setError] =React.useState(false)
    const [success, setSuccess] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
    const [buttonDisabled, setButtonDisabled] = React.useState(false)
    

    const successMessage = 'Payment has been succesfully processed.'


    const changeType = (event) =>{
        
        setType(event.target.value)
    }

    const numberChange = (event) =>{
        setNumberChange(event.target.value)
    }

    const ammountChange = (event) =>{
        setAmmount(event.target.value)
    }

    const errorClose = () =>{
        setError(false)
    }

    const successClose = ()=>{
        setSuccess(false)
    }

    const processPaymentClick = async () => {
        try{
        setButtonDisabled(true)    
        const ammountToString = Number(ammount).toFixed(2)
        
        setProcessingPayment(true)
        
        if (ammount >= totalDue){
            
           await axios({
                method: "POST",
                url: "api/oracle3/paid",
                data: {
                    data: accounts,
                    id: number,
                    mail_documents: 1,
                    totalPaid: ammountToString,
                    paymentType: type

                }
            }).then(async results=>{
                
                if(results.data==='Payment Complete'){
                  const PDFprops = await getProps(accounts, context, ammountToString)  
                  const blob = await pdf(SettlementLetterPDF({...PDFprops})).toBlob()
                  FileSaver.saveAs(blob, file_name)

                  await axios({
                    method: 'POST',
                    url: 'api/oracle4/upload',
                    headers: {'Content-Type': 'application/octet-stream'},
                    params:{fileName: file_name,
                            customer_number: context.customer_number,
                            autogenerated: 1,
                            email: context.email 
                    },
                    data: blob
                  }).then(async (response)=>{
                    if(response.status===200){
                        await axios({
                            method: 'POST',
                            url: 'api/oracle5/confirm',
                            data: {customer_number: context.customer_number,
                                   status: 'PAID',
                                   data: fillData,
                                   file_name: file_name 
                            }
                        }).then(async result=>{
                            if (result.status===200){
                                await axios({
                                    method: 'POST',
                                    url: 'api/oracle3/generateinvoice',
                                    data: {data: accounts,
                                            id: number,
                                            customerInfo: context,
                                            totalDue: ammountToString
                                    }
                                }).then(async result2=>{
                                         
                                        if(result2.data==='Invoice Generated'){
                                    await axios({
                                                    method: 'POST',
                                                    url: 'api/oracle6/postchecktransaction',
                                                    data: {total: ammountToString,
                                                    id: number,
                                                    customer_number: context.customer_number 
                                    }
                                }).then(result3=>{
                                    
                                         if(result3.data==='Transaction Posted'){
                                            setProcessingPayment(false)
                                            setSuccess(true)
                                            setNumberChange(0)
                                            setAmmount(0)
                                            setButtonDisabled(false)
                            } else {
                                setErrorMessage('Something went wrong in the postTransaction call')
                                setError(true)
                                setButtonDisabled(false)
                                setProcessingPayment(false)
                            }
                        }).catch(err=>{
                                    setButtonDisabled(false)
                                    setProcessingPayment(false)
                                    
                                    throw err
                                })
                            } else {
                                setErrorMessage('Something went wrong in the confirm call')
                                setError(true)
                                setButtonDisabled(false)
                                setProcessingPayment(false)
                            }

                        }).catch(err=>{
                                    
                                    setButtonDisabled(false)
                                    setProcessingPayment(false)
                                    throw err
                                })
                            } else {
                                setErrorMessage('Something went wrong in the generateinvoice call')
                                setError(true)
                                setProcessingPayment(false)
                                setButtonDisabled(false)
                                
                            }
                        }).catch(err=>{
                                    
                                    setButtonDisabled(false)
                                    setProcessingPayment(false)
                                    throw err
                                })
                            
                    } else {
                        setErrorMessage('Something went wrong in the upload call')
                        setError(true)
                        setButtonDisabled(false)
                        setProcessingPayment(false)
                    }
                  }).catch(err=>{

                                   
                                    throw err
                                })

                } else{
                    setErrorMessage('Something went wrong in the complete payment call')
                    setButtonDisabled(false)
                    setError(true)
                    setProcessingPayment(false)
                } 

            }).catch(err=>{
                                    
                                    throw err
                                })

        } else {
            
            let partialFillData = getPartialFillData(accounts, totalDue)
            await axios({
                method: 'POST',
                url: 'api/oracle5/partialupdate',
                data:{customer_number: context.customer_number,
                      status: 'Partial',
                      data: partialFillData
                }
            }).then(async result=>{
                if (result.status===200){
                    await axios({
                        method: 'POST',
                        url: 'api/oracle3/generateinvoice',
                        data: {data: accounts,
                               id: number,
                               customerInfo: context,
                               totalDue: ammountToString
                        }
                    }).then(async results=>{
                        if(results.data==='Invoice Generated'){
                            await axios({
                                method: 'POST',
                                url: 'api/oracle6/partialchecktransaction',
                                data: {total: ammountToString,
                                       id: number,
                                       customer_number: context.customer_number  
                                }

                            }).then(result1=>{
                                if(result1.data==='Transaction Posted'){
                                    setProcessingPayment(false)
                                    setSuccess(true)
                                    setNumberChange(0)
                                    setAmmount(0)
                                } else {
                                    setErrorMessage('Something went wrong in the partialchecktransaction call')
                                    setButtonDisabled(false)
                                    setError(true)
                                    setProcessingPayment(false)
                                }
                            }).catch(err=>{
                                    
                                    throw err
                                })
                        }
                    }).catch(err=>{
                                    
                                    throw err
                                })
                } else {
                    setErrorMessage('Something went wrong in the generate invoice call')
                    setButtonDisabled(false)
                    setProcessingPayment(false)
                    setError(true)
                }

            }).catch(err=>{
                                    
                                    throw err
                                })

            
        }
        }
        catch(err){
            let axioserr = axiosErrorHandling(err)
            setErrorMessage(axioserr)
            setError(true)
            setProcessingPayment(false)
            setButtonDisabled(false)

        }

    }


    return(
        <Box sx={{minHeight: '80vh', mt: 14, mb: 2}}>
            <ErrorAlert error={errorMessage} open={error} handleClose={errorClose} />
            <SuccessAlert message={successMessage} setClose={successClose} open={success} />
            <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
                <Grid size={{sm: 4}} sx={{mb: 2}}>    
                    <Typography color='secondary'>Please enter check information here: </Typography>
                </Grid>
            </Grid>
            <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
                
                <Grid size={{sm: 4, md: 3, lg: 2 }}>
                    <FormControl fullWidth>
                        <InputLabel id="Type-Label">Check or Money Order</InputLabel>
                            <Select
                                labelId="checkorMO"
                                id="Check_Money_Order"
                                label="Check or Money Order"
                                value={type}
                                onChange={changeType}
                            >
                                <MenuItem  value={'Check'}>Check</MenuItem>
                                <MenuItem  value={'Money Order'}>Money Order</MenuItem> 
                            </Select>
                    </FormControl>
                </Grid>
            </Grid>
             <Grid container direction='row' spacing={2} sx={{justifyContent:'center', alignItems:'center'}}>
                <Grid size={{sm: 5}}></Grid>
                <Grid size={{sm: 7}}>
                <TextField
                    
                    id='id'
                    label='Check or Money Order Number'
                    type='number'
                    value={number}
                    onChange={numberChange}
                    sx={{mt: 2}}
                    />
                </Grid>
                <Grid size={{sm: 5}}></Grid>
                <Grid size={{sm: 7}}>    
                <TextField
                    
                    id='id'
                    label='Amount of Check/Money Order'
                    type='number'
                    value={ammount}
                    onChange={ammountChange}
                    sx={{mt: 2}}
                    slotProps={{
                                input: {
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        },
                                }}
                    />
                    </Grid>
                    <Grid>
                    <Button
                        variant='contained'
                        endIcon={<CurrencyExchangeIcon/>}
                        onClick={processPaymentClick}
                        loading={processingPayment}
                        loadingPosition='end'
                        disabled={buttonDisabled}
                    >
                    Make Payment
                    </Button>
                    </Grid>
            </Grid>   
        
        </Box>
    )
}